import { eventLocations, eventProperties } from 'client/GrowthEngineering/utilities/GrowthConstants';
import EventHelper from 'client/GrowthEngineering/EventHelper';

const {
  boolean,
  description,
  displayLogic,
  iconName,
  location,
  section,
  submittedText,
  toUrl,
  text: textEventProp,
} = eventProperties;

const {
  homePage,
} = eventLocations;

const investigationPage = 'Investigation Page';

export default {
  EventHelper,

  methods: {
    triggerCheckboxClickedHandler(title, value, text) {
      EventHelper.triggerCheckboxClicked({
        [boolean]: value ? 1 : 0,
        [description]: `Checkbox on/off for ${text} in ${title} metric widgets`,
        [location]: homePage,
        [section]: 'Manage Home Settings',
        [textEventProp]: text,
      });
    },

    triggerToggleClickedHandler(title, value) {
      EventHelper.triggerToggleClicked({
        [description]: `Toggle on/off the small widgets for ${title} widget`,
        [location]: homePage,
        [boolean]: value ? 1 : 0,
        [section]: 'Manage Home Settings',
        [textEventProp]: `Toggle on/off for ${title} widget`,
      });
    },

    triggerInputEnteredHandlerInToolBar(value) {
      EventHelper.triggerInputEntered({
        [description]: 'Search in investigative page list',
        [location]: 'Investigation Page',
        [section]: 'Home widget small investigative page',
        [submittedText]: value,
        [textEventProp]: 'Search',
      });
    },

    triggerInputEnteredHandler(value, display) {
      EventHelper.triggerInputEntered({
        [description]: `Search in ${display} - investigative page list`,
        [location]: 'Investigation Page',
        [section]: 'Home widget small investigative page',
        [submittedText]: value,
        [textEventProp]: 'Search',
      });
    },

    triggerButtonClickedHandler(
      eventDescription,
      eventLocation,
      eventSection,
      eventUrl,
      eventTitle,
    ) {
      EventHelper.triggerButtonClicked({
        [description]: eventDescription,
        [location]: eventLocation,
        [section]: eventSection,
        [toUrl]: eventUrl,
        [textEventProp]: eventTitle,
      });
    },

    triggerCardClickedHandler(title, url) {
      EventHelper.triggerWidgetClicked({
        [description]: `Home widget small for ${title}`,
        [location]: homePage,
        [section]: 'Home widget small',
        [toUrl]: url,
        [textEventProp]: title,
      });
    },

    triggerMDMButtonClickedHandler(title, url) {
      this.triggerButtonClickedHandler(
        `Home widget small for ${title}`,
        homePage,
        'Home widget small',
        url,
        title,
      );
    },

    triggerViewAllButtonClickedHandler(text, element = '') {
      EventHelper.triggerButtonClicked({
        [description]: `Click ${element}action on investigation page`,
        [displayLogic]: 'Visible if investigation has actions',
        [location]: investigationPage,
        [section]: 'Home widget small Investigation page',
        [textEventProp]: text,
      });
    },

    triggerLinkClickedHandler(
      eventDescription,
      eventText,
      eventUrl,
      eventName,
    ) {
      EventHelper.triggerLinkClicked({
        [description]: eventDescription,
        [location]: homePage,
        [section]: eventText,
        [toUrl]: eventUrl,
        [textEventProp]: eventName,
      });
    },

    triggerIconClickedHandler(icon, url) {
      EventHelper.triggerIconClicked({
        [description]: 'Home welcome section manage home button',
        [iconName]: icon,
        [location]: homePage,
        [section]: 'Home welcome section',
        [toUrl]: url,
        [textEventProp]: 'Manage Home',
      });
    },

    triggerWelcomeLinkClickedHandler() {
      EventHelper.triggerLinkClicked({
        [location]: homePage,
        [textEventProp]: 'Generate Value Report',
        [section]: 'Widget Containers',
        [description]: 'The Value Report widget link was clicked.',
        [displayLogic]: 'Only visible for 2022-01-21-value-report',
      });
    },

  },

};
